const API_URL = process.env.REACT_APP_API_URL;

const CONTROLLER = {
  LOGIN: "Login/",
  ANNOUNCEMENT: "Announcement/",
  MEMBER: "Member/",
  DELIVERY_REQUEST: "DeliveryRequest/",
  DASHBOARD: "Dashboard/",
  DRAW: "Draw/",
  LOYALTY: "Loyalty/",
  WORKFLOW: "WorkFlow/",
  COMMON: "Common/",
  CALCULATION: "Calculation/",
  PAYMENT: "PaymentOrder/"
};

const ACTION = {
  //LOGIN
  AUTHENTICATE: "Authenticate",
  CONTROL_CANDIDATE: "ControlCandidate",
  RESEND_CANDIDATE_CODE: "ReSendCandidateCode",
  AUTHENTICATE_CANDIDATE: "AuthenticateCandidate",
  FORGOT_PASSWORD: "ForgotPassword",
  RESET_PASSWORD: "ResetPasswordV2",
  RESET_PASSWORD_WITH_SMS: "ResetPasswordWithSmsV2",
  SENDSMS_FORGOTPASSWORD_WITHOTP: "SendSmsForgotPasswordWithOTP",
  GET: "Get",
  GET_DETAIL: "GetDetail",
  IS_SHOW_MEMBER_APPLICATION: "IsShowMemberApplication",
  AUTHENTICATE_OTP: "AuthenticateOtp",
  AUTHENTICATE_VERIFY: "AuthenticateVerify",
  REFRESH_TOKEN: "RefreshToken",
  GET_SUBMIT_DEMAND_OPTIONS: "GetSubmitDemandOptions",
  GET_MEMBER_FEK: "GetMemberFek",  
  GET_MEMBER_IBAN: "GetMemberIban",  

  //MEMBER
  GET_MEMBER: "GetMember",
  GET_DEBT_SITUATION: "GetDebtSituation",
  GET_MEMBER_INFO: "GetMemberInfo",
  GET_ACCOUNT_INFO: "GetAccountInfo",
  GET_EXPENSES: "GetExpenses",
  GET_EXPENSES_BY_MEMBERNO: "GetExpensesByMemberNo",
  GET_AGENT_INFO: "GetAgentInfo",
  GET_DOCUMENT: "GetDocument",
  GET_MEMBER_NUMBER: "GetMemberNumber",
  GET_FREEZE_DETAIL: "GetMemberFreezeDetail",
  CONTROL_NEW_MEMBER: "ControlNewMember",
  SAVE_NEW_MEMBER: "SaveNewMemberWithOTP",
  SEND_SMS_NEWMEMBER: "SendSmsNewMemberWithOTP",
  CONTROL_CARD_CONTACT_INFO: "ControlCardContactInfo",
  SET_CARD_CONTACT_INFO: "SetCardContactInfo",
  RESEND_VALIDATE_CODE_CONTACT_INFO: "ReSendValidateCodeContactInfo",
  MEMBER_INSTALLMENT_CONTROL: "MemberInstallmentControl",
  FILE_UPLOAD: "FileUpload",
  SEND_DOCUMENTS_FOR_REVIEW: "SendDocumentsForReview",
  DOWNLOAD_CDN_FILE: "DownloadCdnFile",
  DOWNLOAD_REPORT_FILE: "DownloadReport",
  GET_GUARANTORS: "GetGuarantors",
  ADD_GUARANTOR: "AddGuarantor",
  DELETE_GUARANTOR: "DeleteGuarantor",
  GET_MEMBER_DELIVERY_DOCUMENTS: "GetMemberDeliveryDocuments",
  GET_CORPORATE_CARD_OFFICER: "GetCorporateCardOfficer",
  SAVE_DELIVERY_SCOPE_SELECTION: "SaveDeliveryScopeSelection",
  SAVE_SERVICE_RECORD: "SaveServiceRecord",
  CAN_INSTALLMENT_PAYMENT: "CanInstallmentPayment",

  // DELIVERY REQUEST
  GET_SALES_DOCUMENT_REQUESTS: "GetSalesDocumentRequests/",
  GET_SALES_DOCUMENT_REQUEST_DETAIL: "GetSalesDocumentRequestDetail/",
  UPLOAD_SALES_DOCUMENTS: "UploadSalesDocuments/",
  DOWNLOAD_SALES_DOCUMENT: "DownloadSalesDocument/",

  //DRAW
  GET_DRAW_DETAIL: "GetDrawDetail",

  //LOYALTY
  ADD_MEMBER: "AddMember",
  GET_REFERENCES: "GetReferences",
  GET_LOYALTY_RULES: "GetLoyaltyRules",
  ADD_LEAD: "AddLead",

  //WORKFLOW
  ADD_FEEDBACK: "Feedback",
  ODEME_UYUMSUZLUK_TALEP: "OdemeUyumsuzlukTalep",
  GET_MY_DEMANDS: "GetMyDemands",
  DOWNLOAD_DEMAND_FILE: "DownloadDemandFile",
  ASK_TO_AGENT: "AskToAgent",

  //COMMON
  GET_KVKK: "GetKVKK",
  GET_AYDINLATMA_METNI: "GetKVKKWithControl",
  SET_AYDINLATMA_METNI: "SetKVKK",
  GET_CITIES: "GetCity",
  GET_TOWNS: "GetTown/",
  GET_KVKK_METNI: "GetKvkkMetni",
  GET_REFERANS_GECERLILIK_KURALLARI: "GetReferansGecerlilikKurallari",
  GET_SSS: "GetSSS",
  GET_IP: "GetIp",

  //CALCULATION
  GET_CAMPAIGNS: "GetCampaigns/",
  GET_PAYMENT_PLAN: "GetCalculation/",
  SAVE_ADDRESS: "SaveAddress",
  SAVE_PERSONAL_INFO: "SavePersonalInfo",
  SEND_SMS_OFFER_VALIDATION: "SendSmsOfferValidation",
  CHECK_IF_CUSTOMER_HAS_ADDRESS: "CheckIfCustomerHasAddress",
  CHECK_PERSONEL_INFORMATION: "CheckPersonalInformation",
  SAVE_MEMBERSHIP: "SaveMembership",

  //PAYMENT
  GET_ACTIVE_MEMBER_NUMBER:"GetActiveMember",
  GET_ACTIVE_MEMBER_NOLIST:"GetActiveMemberNoList",
  GET_PAYMENTS: "GetPayments",
  GET_PAYMENTS_TEN_YEAR: "GetPaymentsTenYear",
  GET_PAYMENTS_SUM: "GetPaymentsSum",
  ADD_PAYMENT: "AddPayment",
  GET_PAYMENT_DETAIL: "GetPaymentDetail",
  CANCEL_PAYMENT: "CancelPayment",
  AVAILABLE_FOR_ADD_PAYMENT: "AvailableForAddPayment",
  BIN_SEARCH: "BinSearch",
  GET_TOKEN_PAYTR: "GetTokenPayTr",
  ADD_PAYMENT_PAYTR: "AddPaymentPayTr",
  GET_IFRAME_TOKEN_PAYTR: "GetIFrameTokenPayTr",
  GET_PAYMENT_PLANE_PAYTR: "GetPaymentPlanePayTr",
   GET_PAYMENT_PLANE_EMIN_PAY: "GetPaymentPlaneEminPay",
   BIN_SEARCH_EMIN_PAY: "EminPayBinSearch",
};

export { API_URL, CONTROLLER, ACTION };
